import agingInvoicesReducer from "./aging/agingInvoicesSlice";
import agingReducer from "./aging/agingSlice";
import announcementReducer from "./announcement/announcementSlice";
import AnnouncementState from "./announcement/AnnouncementState";
import bolReducer from "./bol/bolSlice";
import BolState from "./bol/BolState";
import changeUserPasswordReducer from "./user/changeUserPasswordSlice";
import ChangeUserPasswordState from "./user/ChangeUserPasswordState";
import claimsReducer from "./claims/claimsSlice";
import ClaimsState from "./claims/ClaimsState";
import commonReducer from "./common/commonSlice";
import CommonState from "./common/CommonState";
import companyReducer from "./company/companySlice";
import CompanyState from "./company/CompanyState";
import companySettingsAccountsReducer from "./company-settings/companySettingsAccountsSlice";
import CompanySettingsAccountsState from "./company-settings/CompanySettingsAccountsState";
import companySettingsShippersReducer from "./company-settings/companySettingsShippersSlice";
import CompanySettingsShippersState from "./company-settings/CompanySettingsShippersState";
import companySettingsUsersReducer from "./company-settings/companySettingsUsersSlice";
import CompanySettingsUsersState from "./company-settings/CompanySettingsUsersState";
import createTeamReducer from "./customers/teams/createTeamSlice";
import CreateTeamState from "./customers/teams/CreateTeamState";
import customerPickupReducer from "./customer-pickup/customerPickupSlice";
import CustomerPickupState from "./customer-pickup/customerPickupState";
import dockLoadingReducer from "./dock-loading/dockLoadingSlice";
import DockLoadingState from "./dock-loading/DockLoadingState";
import emergencyAlertReducer from "./emergency-alert/emergencyAlertSlice";
import EmergencyAlertState from "./emergency-alert/EmergencyAlertState";
import featureBannerReducer from "./feature-banner/featureBannerSlice";
import FeatureBannerState from "./feature-banner/FeatureBannerState";
import feedbackReducer from "./feedback/feedbackSlice";
import FeedbackState from "./feedback/FeedbackState";
import legacyUserReducer from "./user/legacyUserSlice";
import LegacyUserState from "./user/LegacyUserState";
import exportReducer from "./export/exportSlice";
import ExportState from "./export/ExportState";
import filtersToggleReducer from "./filters-toggle/filtersToggleSlice";
import FiltersToggleState from "./filters-toggle/FiltersToggleState";
import forgotPasswordReducer from "./user/forgotPasswordSlice";
import ForgotPasswordState from "./user/ForgotPasswordState";
import fuelSurchargeReducer from "./fuel-surcharge/fuelSurchargeSlice";
import FuelSurchargeState from "./fuel-surcharge/FuelSurchargeState";
import GeneralSettingsState from "./general-settings/GeneralSettingsState";
import inventoryReducer from "./warehouse/inventory/inventorySlice";
import InventoryState from "./warehouse/inventory/InventoryState";
import inviteManagementReducer from "./invite-management/inviteManagementSlice";
import InviteManagementState from "./invite-management/InviteManagementState";
import Invoice, { InvoiceDetails } from "../app/data/invoice/models";
import invoiceDetailsReducer from "./invoice/invoiceSlice";
import invoiceDocumentsReducer from "./invoice-documents/invoiceDocumentsSlice";
import InvoiceDocumentsState from "./invoice-documents/InvoiceDocumentsState";
import invoiceRecordsReducer from "./invoice-records/invoiceRecordsSlice";
import InvoiceRecordsState from "./invoice-records/InvoiceRecordsState";
import JWTGeneratorReducer from "./jwt-generator/JWTGeneratorSlice";
import JWTGeneratorState from "./jwt-generator/JWTGeneratorState";
import metricsReducer from "./metrics/metricsSlice";
import MetricsState from "./metrics/MetricsState";
import notificationsReducer from "./notifications/notificationsSlice";
import NotificationsState from "./notifications/NotificationsState";
import paymentReducer from "./payment/paymentSlice";
import PaymentState from "./payment/PaymentState";
import pendingRequestsReducer from "./customers/pending/pendingRequestsSlice";
import PendingRequestsState from "./customers/pending/PendingRequestsState";
import pickupReducer from "./pickup/pickupSlice";
import PickupState from "./pickup/PickupState";
import pickupAssignmentReducer from "./pickup/pickupAssignmentSlice";
import PickupAssignmentState from "./pickup/PickupAssignmentState";
import pickupDetailsReducer from "./pickup/pickupDetailsSlice";
import PickupDetailsState from "./pickup/PickupDetailsState";
import podRecognitionReducer from "./documents/podRecognitionSlice";
import PodRecognitionState from "./documents/PodRecognitionState";
import portalRegistrationReducer from "./portal-registration/portalRegistrationSlice";
import PortalRegistrationState from "./portal-registration/PortalRegistrationState";
import probillReducer from "./probill/probillPreviewSlice";
import ProbillState from "./probill/ProbillPreviewState";
import profileReducer from "./user/profile/profileSlice";
import ProfileState from "./user/profile/ProfileState";
import publicShipmentDetailsReducer from "./public-shipment-details/publicShipmentDetailsSlice";
import PublicShipmentDetailsState from "./public-shipment-details/PublicShipmentDetailsState";
import ratesReducer from "./rates/ratesSlice";
import RatesState from "./rates/RatesState";
import receiptsReducer from "./warehouse/receipts/receiptsSlice";
import ReceiptsState from "./warehouse/receipts/ReceiptsState";
import recognitionLogsReducer from "./documents/recognitionLogsSlice";
import RecognitionLogsState from "./documents/RecognitionLogsState";
import recordsReducer from "./delivery-records/recordsSlice";
import RecordsState from "./delivery-records/RecordsState";
import reportsReducer from "./reports/reportsSlice";
import ReportsState from "./reports/ReportsState";
import requestRatesReducer from "./rates/requestRatesSlice";
import RequestRatesState from "./rates/RequestRatesState";
import resetPasswordReducer from "./reset-password/resetPasswordSlice";
import ResetPasswordState from "./reset-password/ResetPasswordState";
import returnReducer from "./return/returnSlice";
import ReturnState from "./return/ReturnState";
import serviceCentersReducer from "./service-centers/serviceCentersSlice";
import ServiceCentersState from "./service-centers/ServiceCentersState";
import serviceCentersStatusReducer from "./service-centers-status/serviceCentersStatusSlice";
import ServiceCentersStatusState from "./service-centers-status/ServiceCentersStatusState";
import shipmentDetailsReducer from "./shipment-details/shipmentDetailsSlice";
import ShipmentDetailsState from "./shipment-details/ShipmentDetailsState";
import signupByInviteReducer from "./signup-by-invite/signupByInviteSlice";
import SignupByInviteState from "./signup-by-invite/SignupByInviteState";
import subscriptionsReducer from "./subscriptions/subscriptionsSlice";
import SubscriptionsState from "./subscriptions/SubscriptionsState";
import teamAccountReducer from "./customers/teams/teamAccountSlice";
import TeamAccountState from "./customers/teams/TeamAccountState";
import teamShippersReducer from "./customers/teams/teamShippersSlice";
import TeamShippersState from "./customers/teams/TeamShippersState";
import teamUsersReducer from "./customers/users/teamUsersSlice";
import TeamUsersState from "./customers/users/TeamUsersState";
import trackShipmentReducer from "./track-shipment/trackShipmentSlice";
import TrackShipmentState from "./track-shipment/TrackShipmentState";
import trailerLocationReducer from "./trailer-location/trailerLocationSlice";
import TrailerLocationState from "./trailer-location/TrailerLocationState";
import transactionsReducer from "./warehouse/transactions/transactionsSlice";
import TransactionsState from "./warehouse/transactions/TransactionsState";
import transitCalculatorReducer from "./transit-calculator/transitCalculatorSlice";
import TransitCalculatorState from "./transit-calculator/TransitCalculatorState";
import userReducer from "./user/userSlice";
import UserState from "./user/UserState";
import xgsInlineSwitchReducer from "./xgs-inline-switch/xgsInlineSwitchSlice";
import XgsInlineSwitchState from "./xgs-inline-switch/XgsInlineSwitchState";
import { Aging } from "../app/data/aging/models";
import { combineReducers } from "redux";
import { HolidayCalendarState } from "./holiday-calendar/holidayCalendarState";
import { holidayCalendarReducer } from "./holiday-calendar/holidayCalendarSlice";
import { StandingAppointmentState } from "./customers/standing-appointment/standingAppointmentState";
import { standingAppointmentReducer } from "./customers/standing-appointment/standingAppointmentSlice";
import CompanyAccountDetailsState from "./company-settings/companyAccountDetailsState";
import companyAccountDetailsReducer from "./company-settings/companyAccountDetailsSlice";
import ManifestsState from './manifest/ManifestsState'
import { manifestsReducer } from './manifest/manifestSlice'
import TeamAccountContactState from "./customers/teams/teamAccountContactState";
import teamAccountContactReducer from "./customers/teams/teamAccountContactSlice";
import { AppointmentState } from "./appointments/appointmentsState";
import appointmentReducer from "./appointments/appointmentsSlice";
import generalSettingsReducer from "./general-settings/generalSettingsSlice";
import { ExceptionState } from "./exceptions/exceptionsState";
import { exceptionReducer } from "./exceptions/exceptionsSlice";
import { LinehaulMileageState } from "./linehaul-mileage/linehaulMileageState";
import linehaulMileageReducer from "./linehaul-mileage/linehaulMileageSlice";
import shipperReducer from "./shipper/shipperSlice";
import ShipperState from "./shipper/ShipperState";
import { DispatchCreateRouteState, DispatchEditRouteDetailsState, DispatchPlanProbillsState, DispatchSelectedProbillsState } from "./dispatch-planning/dispatchProbillsState";
import dispatchSelectedProbillsReducer from "./dispatch-planning/dispatchSelectedProbillsSlice";
import dispatchPlanProbillsReducer from "./dispatch-planning/dispatchPlanProbillsSlice";
import dispatchCreateRouteReducer from "./dispatch-planning/dispatchCreateRouteSlice";
import { ActiveRoutesState, AddProbillsToRouteState, AddStopsToRouteState, CreatePicklistFromRouteState, DeleteRouteState, ProbillsToAddToRouteState, RemoveProbillFromRouteState, RemoveStopFromRouteState, RequestRouteOptimizationState, RouteStopsState, StopsToAddToRouteState, UpdateRouteState } from "./dispatch-planning/routes/routesState";
import activeRoutesReducer from "./dispatch-planning/routes/activeRoutesSlice";
import routeStopsReducer from "./dispatch-planning/routes/routeStopsSlice";
import picklistDetailsReducer from "./dispatch-planning/picklists/picklistDetailsSlice";
import { ConvertPicklistToRouteState, PicklistDetailsState, PicklistPdfState, PicklistsLoadingStatusState } from "./dispatch-planning/picklists/picklistsState";
import updateRouteReducer from "./dispatch-planning/routes/updateRouteSlice";
import addProbillsToRouteReducer from "./dispatch-planning/routes/addProbillsToRouteSlice";
import probillsToAddToRouteReducer from "./dispatch-planning/routes/probillsToAddToRouteSlice";
import stopsToAddToRouteReducer from "./dispatch-planning/routes/stopsToAddToRouteSlice";
import addStopsToRouteReducer from "./dispatch-planning/routes/addStopsToRouteSlice";
import removeProbillFromRouteReducer from "./dispatch-planning/routes/removeProbillFromRouteSlice";
import removeStopFromRouteReducer from "./dispatch-planning/routes/removeStopFromRouteSlice";
import requestRouteOptimizationReducer from "./dispatch-planning/routes/optimizeRouteSlice";
import createPicklistFromRouteReducer from "./dispatch-planning/routes/createPicklistFromRouteSlice";
import planningTipsReducer from "./dispatch-planning/planningTips/planningTipsSlice";
import { PlanningTipsState } from "./dispatch-planning/planningTips/planningTipsState";
import picklistPdfReducer from "./dispatch-planning/picklists/picklistPdfSlice";
import convertPicklistToRouteReducer from "./dispatch-planning/picklists/convertPicklistToRouteSlice";
import dispatchEditRouteDetailsReducer from "./dispatch-planning/dispatchEditRouteDetailsSlice";
import deleteRouteReducer from "./dispatch-planning/routes/deleteRouteSlice";
import { UnplannableProbillsState } from "./dispatch-planning/unplannable-probills/unplannableProbillsState";
import unplannableProbillsReducer from "./dispatch-planning/unplannable-probills/unplannableProbillsSlice";
import picklistsLoadingStatusReducer from "./dispatch-planning/picklists/picklistsLoadingStatusSlice";
import chatReducer from "./chat/chatSlice";
import ChatState from "./chat/ChatState";
import DownloadState from "./download/DownloadState";
import downloadReducer from "./download/downloadSlice";
import accountInapplicableInformationReducer from "./account-inapplicable-information/accountInapplicableInformationSlice";
import { AccountInapplicableInformationState } from "./account-inapplicable-information/accountInapplicableInformationState";
import { WarehouseInventoryState } from "./warehouse-inventory/warehouseInventoryState";
import warehouseInventoryReducer from "./warehouse-inventory/warehouseInventorySlice";
import serviceDisruptionProbillsReducer from "./dispatch-planning/service-disruption/serviceDisruptionProbillsSlice";
import { CreateLateReasonsState, ServiceDisruptionProbillsState, ServiceDisruptionSelectedProbillsState } from "./dispatch-planning/service-disruption/serviceDisruptionState";
import serviceDisruptionSelectedProbillsReducer from "./dispatch-planning/service-disruption/serviceDisruptionSelectedProbillsSlice";
import createLateReasonsReducer from "./dispatch-planning/service-disruption/createLateReasonsSlice";
import TerminalSummaryState from "./terminal-summary/TerminalSummaryState";
import terminalSummaryReducer from "./terminal-summary/terminalSummarySlice";
import TerminalActivitylogState from "./terminal-summary/ActivityLogState";
import teminalActivityLogReducer from "./terminal-summary/activityLogSlice";
import { TerminalTileLoadingStatusState } from "./terminal-summary/terminalSummaryTiles/terminalTilesState";
import terminalTileLoadingStatusReducer from "./terminal-summary/terminalSummaryTiles/terminalTilesLoadingStatusSlice";
import { TerminalState } from "./terminal-summary/TerminalDetailsState";
import terminalReducer from "./terminal-summary/terminalDetailsSlice";
import { UpdateAddressState } from "./terminal-summary/AddressState";
import updateAddressReducer from "./terminal-summary/addressSlice";
import { UpdateContactState } from "./terminal-summary/ContactState";
import updateContactReducer from "./terminal-summary/contactSlice";
import { UpdateRegionState } from "./terminal-summary/RegionState";
import updateRegionReducer from "./terminal-summary/regionSlice";
import { UpdateBasicInfoState } from "./terminal-summary/BasicInfoState";
import updateBasicInfoReducer from "./terminal-summary/basicInfoSlice";
import { DeleteTerminalState } from "./terminal-summary/DeleteState";
import deleteTerminalReducer from "./terminal-summary/deleteSlice";
import { UpdateAdditionalSettingsState } from "./terminal-summary/AdditionalSettingsState";
import updateAdditionalSettingsReducer from "./terminal-summary/additionalSettingsSlice";
import terminalChangeLogReducer from "./terminal-summary/changelogSlice";
import TerminalChangelogState from "./terminal-summary/ChangelogState";
import { UpdateStatusState } from "./terminal-summary/TerminalStatusState";
import updateStatusReducer from "./terminal-summary/terminalStatusSlice";
import { UpdateOriginalCountsState } from "./terminal-summary/terminalSummaryTiles/OriginalCountsState";
import originalCountsReducer from "./terminal-summary/terminalSummaryTiles/originalCountsSlice";
import operationsAccessorialApprovalReducer from "./shipment-reconciliation/operations-review/operationAccessorialsApprovalSlice";
import getOperationsReviewListReducer from "./shipment-reconciliation/operations-review/getOperationsReviewListSlice";
import getOperationsReviewSummaryReducer from "./shipment-reconciliation/operations-review/getOperationsReviewSummarySlice";
import { AccessorialRevenueDailyTrendState, AccessorialRevenueTrendIndicatorsState, AccessorialReviewPerformanceSummaryState, AccessorialReviewTerminalPerformanceState, BillingAccessorialApprovalState, BillingReviewListState, BillingReviewSummaryState, ExportBillingReviewListState, ExportOperationsReviewListState, OperationsAccessorialApprovalState, OperationsReviewListState, OperationsReviewSummaryState, ShipmentWorkItemAccessorialsState } from "./shipment-reconciliation/ShipmentReconciliationState";
import billingAccessorialApprovalReducer from "./shipment-reconciliation/billing-review/billingAccessorialsApprovalSlice";
import getBillingReviewListReducer from "./shipment-reconciliation/billing-review/getBillingReviewListSlice";
import getBillingReviewSummaryReducer from "./shipment-reconciliation/billing-review/getBillingReviewSummarySlice";
import shipmentWorkItemAccessorialsReducer from "./shipment-reconciliation/shipmentWorkItemAccessorialsSlice";
import { AddressState } from "./address-manager/AddressState";
import addressReducer from "./address-manager/addressSlice";
import accessorialReviewPerformanceSummaryReducer from "./shipment-reconciliation/dashboard/accessorialPerformaceSummarySlice";
import accessorialReviewTerminalPerformanceReducer from "./shipment-reconciliation/dashboard/accessorialReviewTerminalPerformanceSlice";
import exportOperationsReviewListReducer from "./shipment-reconciliation/operations-review/exportOperationsReviewListSlice";
import exportBillingReviewListReducer from "./shipment-reconciliation/billing-review/exportBillingReviewListSlice";
import accessorialRevenueDailyTrendReducer from "./shipment-reconciliation/revenue-insights/accessorialRevenueDailyTrendSlice";
import accessorialRevenueTrendIndicatorsReducer from "./shipment-reconciliation/revenue-insights/accessorialRevenueTrendIndicatorsSlice";
import ZipcodeLocationsState from "./zipcode-locations/ZipcodeLocationsState";
import zipcodeLocationsReducer from "./zipcode-locations/zipcodeLocationsSlice";
import { DriverState } from "./drivers/DriverState";
import driversReducer from "./drivers/driversSlice";
import unassignedPickupReducer from "./pickup/unassignedPickupSlice";
import { UnassignedPickupState } from "./pickup/UnassignedPickupState";

export interface BaseState {
  loading: boolean;
  loadingFailed: boolean;
  loadingError?: string | null;
  loaded: boolean;
}

export interface AgingState extends BaseState {
  data: Aging | null | undefined;
}

export interface AgingInvoicesState extends BaseState {
  invoices: Invoice[];
  needToReload?: boolean;
  lastIds: string | null | undefined;
  loadingPortion: boolean;
  loadedAll: boolean;
  loadingCSV: boolean;
  loadingFailedCSV: boolean;
  invoicesCSV: Invoice[];
}

export interface InvoiceDetailsState extends BaseState {
  invoiceDetails: InvoiceDetails | null | undefined;
  needToReload: boolean | null | undefined;
}

export interface IState {
  accessorialRevenueDailyTrend: AccessorialRevenueDailyTrendState;
  accessorialRevenueTrendIndicators: AccessorialRevenueTrendIndicatorsState;
  accessorialReviewPerformanceSummary: AccessorialReviewPerformanceSummaryState;
  accessorialReviewTerminalPerformance: AccessorialReviewTerminalPerformanceState;
  accountInapplicableInformation: AccountInapplicableInformationState;
  activeRoutes: ActiveRoutesState;
  addProbillsToRoute: AddProbillsToRouteState;
  address: AddressState;
  addStopsToRoute: AddStopsToRouteState;
  aging: AgingState;
  agingInvoices: AgingInvoicesState;  
  announcement: AnnouncementState;
  appointment: AppointmentState;
  billingAccessorialApproval: BillingAccessorialApprovalState;
  billingReviewList: BillingReviewListState;
  billingReviewSummary: BillingReviewSummaryState;
  bol: BolState;
  changeUserPassword: ChangeUserPasswordState;
  chat: ChatState;
  claims: ClaimsState;
  common: CommonState;
  companyAccountDetails: CompanyAccountDetailsState;
  companySettingsAccounts: CompanySettingsAccountsState;
  companySettingsShippers: CompanySettingsShippersState;
  companySettingsUsers: CompanySettingsUsersState;
  convertPicklistToRoute: ConvertPicklistToRouteState;
  createLateReasons: CreateLateReasonsState;
  createPicklistFromRoute: CreatePicklistFromRouteState;
  createTeam: CreateTeamState;
  customerPickup: CustomerPickupState;
  deleteRoute: DeleteRouteState;
  deleteTerminal: DeleteTerminalState;
  dispatchCreateRoute: DispatchCreateRouteState;
  dispatchEditRouteDetails: DispatchEditRouteDetailsState;
  dispatchPlanProbills: DispatchPlanProbillsState;
  dispatchSelectedProbills: DispatchSelectedProbillsState;
  dockLoading: DockLoadingState;
  download: DownloadState;
  driver: DriverState;
  emergencyAlert: EmergencyAlertState;
  exception: ExceptionState;
  export: ExportState;
  exportBillingReviewList: ExportBillingReviewListState;
  exportOperationsReviewList: ExportOperationsReviewListState;
  featureBanner: FeatureBannerState;
  feedback: FeedbackState;
  filtersToggle: FiltersToggleState;
  forgotPassword: ForgotPasswordState;
  fuelSurcharge: FuelSurchargeState;
  generalSettings: GeneralSettingsState;
  holidayCalendar: HolidayCalendarState;
  inventory: InventoryState;
  inviteManagement: InviteManagementState;
  invoiceDetails: InvoiceDetailsState;
  invoiceDocuments: InvoiceDocumentsState;
  invoiceRecords: InvoiceRecordsState;
  jwtGenerator: JWTGeneratorState;
  legacyUser: LegacyUserState;
  linehaulMileage: LinehaulMileageState;
  manifests: ManifestsState;
  metrics: MetricsState;
  notifications: NotificationsState;
  operationsAccessorialApproval: OperationsAccessorialApprovalState;
  operationsReviewList: OperationsReviewListState; 
  operationsReviewSummary: OperationsReviewSummaryState;
  originalCounts: UpdateOriginalCountsState,
  payment: PaymentState;
  pendingRequests: PendingRequestsState;
  picklistDetails: PicklistDetailsState;
  picklistPdf: PicklistPdfState;
  picklistsLoadingStatus: PicklistsLoadingStatusState;
  pickup: PickupState;
  pickupAssignment: PickupAssignmentState;
  pickupDetails: PickupDetailsState;
  planningTips: PlanningTipsState;
  podRecognition: PodRecognitionState;
  portalRegistration: PortalRegistrationState;
  probill: ProbillState;
  probillsToAddToRoute: ProbillsToAddToRouteState;
  profile: ProfileState;
  publicShipmentDetails: PublicShipmentDetailsState;
  rates: RatesState;
  receipts: ReceiptsState;
  recognitionLogs: RecognitionLogsState;
  records: RecordsState;
  removeProbillFromRoute: RemoveProbillFromRouteState;
  removeStopFromRoute: RemoveStopFromRouteState;
  reports: ReportsState;
  requestRates: RequestRatesState;
  requestRouteOptimization: RequestRouteOptimizationState;
  resetPassword: ResetPasswordState;
  return: ReturnState;
  routeStops: RouteStopsState;
  serviceCenters: ServiceCentersState;
  serviceCentersStatus: ServiceCentersStatusState;
  serviceDisruptionProbills: ServiceDisruptionProbillsState;
  serviceDisruptionSelectedProbills: ServiceDisruptionSelectedProbillsState;
  shipmentDetails: ShipmentDetailsState;
  shipmentWorkItemAccessorials: ShipmentWorkItemAccessorialsState;
  shipper: ShipperState;
  signupByInvite: SignupByInviteState;
  standingAppointment: StandingAppointmentState;
  stopsToAddToRoute: StopsToAddToRouteState;
  subscriptions: SubscriptionsState;
  teamAccount: TeamAccountState;
  teamAccountContact: TeamAccountContactState;
  teams: CompanyState;
  teamShippers: TeamShippersState;
  teamUsers: TeamUsersState;
  terminal: TerminalState;
  trackShipment: TrackShipmentState;
  terminalChangelog: TerminalChangelogState;
  terminalSummary: TerminalSummaryState;
  terminalActivitylog: TerminalActivitylogState;
  terminalTileLoadingStatus:TerminalTileLoadingStatusState;
  trailerLocation: TrailerLocationState;
  transactions: TransactionsState;
  transitCalculator: TransitCalculatorState;
  unassignedPickup: UnassignedPickupState;
  unplannableProbills: UnplannableProbillsState;
  updateAdditionalSettings: UpdateAdditionalSettingsState;
  updateAddress: UpdateAddressState;
  updateBasicInfo: UpdateBasicInfoState;
  updateContact: UpdateContactState;
  updateRegion: UpdateRegionState;
  updateRoute: UpdateRouteState;
  updateStatus: UpdateStatusState;
  user: UserState;
  warehouseInventory: WarehouseInventoryState;
  xgsInlineSwitch: XgsInlineSwitchState;
  zipcodeLocations: ZipcodeLocationsState;
  // please add new lines in alphabetical order
};

const appReducer = combineReducers({
  accessorialRevenueDailyTrend: accessorialRevenueDailyTrendReducer,
  accessorialRevenueTrendIndicators: accessorialRevenueTrendIndicatorsReducer,
  accessorialReviewPerformanceSummary: accessorialReviewPerformanceSummaryReducer,
  accessorialReviewTerminalPerformance: accessorialReviewTerminalPerformanceReducer,
  accountInapplicableInformation: accountInapplicableInformationReducer,
  activeRoutes: activeRoutesReducer,
  addProbillsToRoute: addProbillsToRouteReducer,
  addStopsToRoute: addStopsToRouteReducer,
  address: addressReducer,
  aging: agingReducer,
  agingInvoices: agingInvoicesReducer,  
  announcement: announcementReducer,
  appointment: appointmentReducer,
  billingAccessorialApproval: billingAccessorialApprovalReducer,
  billingReviewList: getBillingReviewListReducer, 
  billingReviewSummary: getBillingReviewSummaryReducer,
  bol: bolReducer,
  changeUserPassword: changeUserPasswordReducer,
  chat: chatReducer,
  claims: claimsReducer,
  common: commonReducer,
  companyAccountDetails: companyAccountDetailsReducer,
  companySettingsAccounts: companySettingsAccountsReducer,
  companySettingsShippers: companySettingsShippersReducer,
  companySettingsUsers: companySettingsUsersReducer,
  convertPicklistToRoute: convertPicklistToRouteReducer,
  createLateReasons: createLateReasonsReducer,
  createPicklistFromRoute: createPicklistFromRouteReducer,
  createTeam: createTeamReducer,
  customerPickup: customerPickupReducer,
  deleteRoute: deleteRouteReducer,
  deleteTerminal: deleteTerminalReducer,
  dispatchCreateRoute: dispatchCreateRouteReducer,
  dispatchEditRouteDetails: dispatchEditRouteDetailsReducer,
  dispatchPlanProbills: dispatchPlanProbillsReducer,
  dispatchSelectedProbills: dispatchSelectedProbillsReducer,
  dockLoading: dockLoadingReducer,
  download: downloadReducer,
  driver: driversReducer,
  emergencyAlert: emergencyAlertReducer,
  exception: exceptionReducer,
  export: exportReducer,
  exportOperationsReviewList: exportOperationsReviewListReducer,
  exportBillingReviewList: exportBillingReviewListReducer,
  featureBanner: featureBannerReducer,
  feedback: feedbackReducer,
  filtersToggle: filtersToggleReducer,
  forgotPassword: forgotPasswordReducer,
  fuelSurcharge: fuelSurchargeReducer,
  generalSettings: generalSettingsReducer,
  holidayCalendar: holidayCalendarReducer,
  inventory: inventoryReducer,
  inviteManagement: inviteManagementReducer,
  invoiceDetails: invoiceDetailsReducer,
  invoiceDocuments: invoiceDocumentsReducer,
  invoiceRecords: invoiceRecordsReducer,
  jwtGenerator: JWTGeneratorReducer,
  legacyUser: legacyUserReducer,
  linehaulMileage: linehaulMileageReducer,
  manifests: manifestsReducer,
  metrics: metricsReducer,
  notifications: notificationsReducer,
  operationsAccessorialApproval: operationsAccessorialApprovalReducer,
  operationsReviewList: getOperationsReviewListReducer, 
  operationsReviewSummary: getOperationsReviewSummaryReducer,
  originalCounts: originalCountsReducer,
  payment: paymentReducer,
  pendingRequests: pendingRequestsReducer,
  picklistDetails: picklistDetailsReducer,
  picklistPdf: picklistPdfReducer,
  picklistsLoadingStatus: picklistsLoadingStatusReducer,
  pickup: pickupReducer,
  pickupAssignment: pickupAssignmentReducer,
  pickupDetails: pickupDetailsReducer,
  planningTips: planningTipsReducer,
  podRecognition: podRecognitionReducer,
  portalRegistration: portalRegistrationReducer,
  probill: probillReducer,
  probillsToAddToRoute: probillsToAddToRouteReducer,
  profile: profileReducer,
  publicShipmentDetails: publicShipmentDetailsReducer,
  rates: ratesReducer,
  receipts: receiptsReducer,
  recognitionLogs: recognitionLogsReducer,
  records: recordsReducer,
  removeProbillFromRoute: removeProbillFromRouteReducer,
  removeStopFromRoute: removeStopFromRouteReducer,
  reports: reportsReducer,
  requestRates: requestRatesReducer,
  requestRouteOptimization: requestRouteOptimizationReducer,
  resetPassword: resetPasswordReducer,
  return: returnReducer,
  routeStops: routeStopsReducer,
  serviceCenters: serviceCentersReducer,
  serviceCentersStatus: serviceCentersStatusReducer,
  serviceDisruptionProbills: serviceDisruptionProbillsReducer,
  serviceDisruptionSelectedProbills: serviceDisruptionSelectedProbillsReducer,
  shipmentDetails: shipmentDetailsReducer,
  shipmentWorkItemAccessorials: shipmentWorkItemAccessorialsReducer,
  shipper: shipperReducer,
  signupByInvite: signupByInviteReducer,
  standingAppointment: standingAppointmentReducer,
  stopsToAddToRoute: stopsToAddToRouteReducer,
  subscriptions: subscriptionsReducer,
  teamAccount: teamAccountReducer,
  teamAccountContact: teamAccountContactReducer,
  teams: companyReducer,
  teamShippers: teamShippersReducer,
  teamUsers: teamUsersReducer,
  terminal: terminalReducer,
  terminalChangelog: terminalChangeLogReducer,
  trackShipment: trackShipmentReducer,
  terminalSummary: terminalSummaryReducer,
  terminalActivitylog: teminalActivityLogReducer,
  terminalTileLoadingStatus: terminalTileLoadingStatusReducer,
  trailerLocation: trailerLocationReducer,
  transactions: transactionsReducer,
  transitCalculator: transitCalculatorReducer,
  unassignedPickup: unassignedPickupReducer,
  unplannableProbills: unplannableProbillsReducer,
  updateBasicInfo: updateBasicInfoReducer,
  updateRoute: updateRouteReducer,
  user: userReducer,
  updateAdditionalSettings: updateAdditionalSettingsReducer,
  updateAddress: updateAddressReducer,
  updateContact: updateContactReducer,
  updateRegion: updateRegionReducer,
  updateStatus: updateStatusReducer,
  warehouseInventory: warehouseInventoryReducer,
  xgsInlineSwitch: xgsInlineSwitchReducer,
  zipcodeLocations: zipcodeLocationsReducer
  // please add new lines in alphabetical order
});

const rootReducer = (state: any, action: any) => {
  return appReducer((action.type === "FULL_RESET") ? { user: state.user } : state, action);
};

export default rootReducer;
